import { motion } from 'framer-motion';
import { useI18n } from '../context/I18nContext';
import { Monitor, CreditCard, RefreshCw } from 'lucide-react';

const stepIcons = [Monitor, CreditCard, RefreshCw];

export const LicensingSection = () => {
  const { t } = useI18n();
  const steps = t('licensing.steps');
  const faqs = t('licensing.faq');

  return (
    <section id="pricing" className="relative py-16 sm:py-24 md:py-32 bg-background" data-testid="licensing-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-10 sm:mb-16">
          <span className="text-xs uppercase tracking-[0.2em] text-amber-600 dark:text-amber-400/70 font-medium" data-testid="licensing-tag">{t('licensing.tag')}</span>
          <h2 className="font-heading text-2xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-foreground mt-3" data-testid="licensing-title">{t('licensing.title')}</h2>
        </motion.div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-12 sm:mb-20">
          {Array.isArray(steps) && steps.map((s, i) => {
            const Icon = stepIcons[i];
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="relative p-8 rounded-2xl bg-card border border-border" data-testid={`licensing-step-${i}`}>
                <span className="font-heading text-5xl font-bold text-muted-foreground/20 absolute top-4 right-6">{s.number}</span>
                <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-amber-600 dark:text-amber-400" />
                </div>
                <h3 className="text-foreground font-semibold text-lg mb-2">{s.title}</h3>
                <p className="text-muted-foreground text-sm">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
        <div className="max-w-2xl">
          <div className="space-y-4">
            {Array.isArray(faqs) && faqs.map((f, i) => (
              <motion.div key={i} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="flex gap-4" data-testid={`licensing-faq-${i}`}>
                <span className="text-muted-foreground text-sm font-medium shrink-0">Q:</span>
                <div>
                  <p className="text-foreground/80 text-sm font-medium">{f.q}</p>
                  <p className="text-muted-foreground text-sm mt-1">{f.a}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
